import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import api from "../../../../api/api";
import FormBranch from "../../../../components/common/forms/FormBranch";
import FormButtom from "../../../../components/common/forms/FormButtom";
import FormPayment from "../../../../components/common/forms/FormPayment";
import MainObjectives from "../../../../components/common/forms/MainObjectives";
import { useForm } from "react-hook-form";
import { useLocation, useParams } from "react-router-dom";
import {
  banijiya_registration_business_details,
  pvt_details_of_shareholder_v2,
  banijiya_registration_v2,
  banijiya_shareholder,
  banijiya_shareholder_v2,
  banijiya_registration_upload_document,
  banijiya_registration_upload_document_v3,
  banijiya_registration,
} from "../BanijyaCompanyRegistration/BanijiyaRegistrationForm";
import CompanySearch from "../../../../components/common/forms/CompanySearch";
import ComapanyNameDetails from "../../../../components/common/forms/ComapanyNameDetails";
import ComapanyNameChange from "../AmendmentAndUpdate/ComapanyNameChange/ComapanyNameChange";
import PrivateCompanyModal from "../../../../components/common/modal/CompanyFeeModal";
import DetailsOfShareHolders from "../../../../components/common/forms/DetailsOfShareHolders";
import { v4 as uuidv4 } from "uuid";
import Documents from "../../../../components/common/forms/Documents";
import DualFormRadio from "../../../../components/common/forms/DualFormRadio";
import AdminSearchCustomer from "../../common/AdminSearchCustomer";
import { useSelector } from "react-redux";

const BanijyaCompanyRegistrationB = () => {
  const { register, handleSubmit, unregister } = useForm();
  const { state } = useLocation();
  const { slug } = useParams();
  const [docsOutput, setDocsOutput] = useState([]);
  const [companyType, setCompanyType] = useState(false);
  // const [radioForm, setRadioForm] = useState(false)
  const [uploadProof, setUploadProof] = useState('')
  const [shareHolders, setShareHolders] = useState([
    {
      ...banijiya_shareholder,
      id: uuidv4(),
    },
  ]);
  const { user, isSuccess } = useSelector((state) => state.auth);
  const [userID, setUserId] = useState(null)

  const [paymentRangeList, setPaymentList] = useState([])
  const [amount, setAmount] = useState(0)
  const [totalAmount, setTotalAmount] = useState(0)
  const [dueAmount, setDueAmount] = useState(null)
  const [paidAmount, setPaidAmount] = useState(null)


  
  // For amount calculation
  useEffect(() => {
    if(amount > 0){
      let arr = paymentRangeList.filter((item) => { 
        return amount >= parseInt(item.range_start) && amount <= parseInt(item.range_end)
      })
      console.log(arr)

      arr.length > 0  && setTotalAmount(arr[0]?.amount)
    }else{
      setTotalAmount(0)
    }
  }, [amount, paymentRangeList])

   // getting current user
   useEffect(()=> {
    api.get("/users/me/")
    .then(response=> {
        setDueAmount(response.due_amount)
    }).catch(error=> {

    }) 
  },[])

  // for filtering by company_type and show in Modal
  useEffect(() => {
    api.get('/services/company/registration/service-charges/?company_type=banijya_new')
    .then(response=> {
        // console.log(response.data)
        setPaymentList(response.data)
    }).catch(error=> {
       console.log(error)
    })
  }, [])
  

// while changing type setting amount 0
useEffect(() => {
    setAmount(0)
}, [companyType])





  useEffect(() => {
    if (!companyType) {
      banijiya_registration.map((item) => {
        unregister(item.name);
      });
      // console.log("type", companyType);
      // unregister("owner_address");
    } else {
      banijiya_registration_v2.map((item) => {
        unregister(item.name);
      });
    }
  }, [unregister, companyType]);

  const handleClick = (datas) => {
    datas.share_holders = shareHolders;
    

    // popping documents
    let docsLatest = docsOutput;
    docsLatest.pop();

    datas.documents = docsLatest;
    // console.log(data);

    // data.user = user.user_id

    if(user?.user_type === "CL"){
      const user = JSON.parse(localStorage.getItem("user"));
      datas.user = user.user_id;
    }else {
        if(userID !== null){
            datas.user = userID
        }
    
      } 

    api
      .post("/services/company/", datas)
      .then((response) => {
        toast.success("Data Registered Successfully.");

        let transactions = {
          // payment_mode: "e_wallet",
          amount: paidAmount,
          service_object_id: response.data.registration_id,
          created_by: response.data.registration_id,
          service_object_content_type: response.data.service_content_type_id,
          payment_proof : uploadProof,
          company : response.data.company_id,
          transaction_type: "credit"
       
        };

        api
          .post("/transactions/", transactions)
          .then((response) => {
            toast.success("Data Registered 2 Successfully.");
          })
          .catch((error) => {
            toast.error("Error in Transaction");
          });
      })
      .catch((err) => {
        // console.log(err);
        toast.error("Data Registration Failed.");
      });
  };

  let data = [];

   banijiya_registration_upload_document.map((item, i)=> {
    data.push({ id: uuidv4(), image: "", document_name: "" });
    return "";
   })


  return (
    //  <div>test</div>
    <div>
      <form className="">
        {/* <p className=" text-primary-red text-xl font-semibold flex justify-center">
          Banijaya Registration Form (कम्पनीलाई बाणिज्य विभागमा दर्ताको लागि)
        </p> */}
          <div className="mt-3">
          {

           (user?.user_type === "ST" || user?.user_type === "AD")
            && <AdminSearchCustomer 
             setUserId={setUserId}
            /> 
          }
         </div>


        <div className=" text-primary-blue  my-3  text-lg underline">
          1.Business Name Details
        </div>
        <ComapanyNameDetails register={register} />
        <div>
          {/* <CompanySearch /> */}
          {/* <div><ComapanyNameDetails register={register}/></div> */}
          {/* <ComapanyNameDetails/> */}
          {/* <ComapanyNameChange/> */}
          <p className="text-primary-blue text-lg my-3 underline">
            2. Others Details
          </p>

          {/* <div className="flex">
            <th className="border-primary-blue text-primary-red border px-10 text-lg font-bold">
              ब्यवसायको प्रकार
            </th>
            <tr className="border-primary-blue flex text-primary-red border px-20 text-base font-bold sm:text-lg">
              <td className="border-primary-blue bg-primary-red flex items-center justify-center gap-1 rounded-full border p-1 text-white">
                <label htmlFor="">एकल </label>
                <input type="radio" name="radio-btn" id="" />
              </td>
              <td className="border-primary-blue bg-primary-red rounded-full border-l p-1 text-white">
                <label htmlFor="">साझेदारी </label>
                <input type="radio" name="radio-btn" id="" />
              </td>
            </tr>
          </div> */}

          {/* <div className="border-primary-blue flex border md:w-[57%]" >
                  <p className="text-primary-red px-5 py-2  border-l sm:!w-[33%]">
                  ब्यवसायको प्रकार
                  </p>
                  <div className=" border-l-2 flex  border-primary-blue">
                  <div onClick={companyTypeHandleA} className="cursor-pointer  border-primary-blue px-1 ml-2 flex items-center my-2 rounded-2xl gap-2  bg-red-500">
                  <label htmlFor=""  className="text-white">एकल</label>
                  
                  <div className={`${companyType===true?"bg-yellow-400":"bg-white"} rounded-full w-3 h-3 `}> </div>
                  </div>
                  <div onClick={companyTypeHandleB} className="cursor-pointer border-primary-blue px-1 ml-2 flex items-center my-2 rounded-2xl gap-2  bg-red-500 ">
                  <label htmlFor=""  className="text-white">साझेदारी 
                  </label>
                  
                  <div className={`${companyType===false?"bg-yellow-400":"bg-white"} rounded-full w-3 h-3 `}> </div>
                  </div>
                  </div>
                </div> */}
          <DualFormRadio
            register={register}
            setCompanyType={setCompanyType}
            companyType={companyType}
          />

          <div className="flex items-center flex-col md:flex-row gap-5">
            {companyType === true ? (
              <>
                <div className="border-primary-blue md:w-[60rem] mt-5 border-2 font-bold">
                  {banijiya_registration.map((item, i) => {
                    const { name, validation, ip1, type } = item;

                    return (
                      <div
                        key={i}
                        className="border-primary-blue flex flex-col border-b md:flex-row"
                      >
                        <p className="text-primary-red px-5 py-2 font-Laila md:w-[350px]">
                          {ip1}
                        </p>
                        <input
                          type={type}
                          name={name}
                          className="border-primary-blue w-full md:border-t-0 border-t py-2 pl-3 outline-none md:border-l"
                          {...register(`${name}`, { required: false,           
                          onChange: (e) => {e.target.name === "capital_to_invest" && setAmount(e.target.value)} })}
                          
                        />
                      </div>
                    );
                  })}
                  <div className="text-primary-blue max-w-3xl font-Laila border-t border-primary-blue px-5 py-2 text-center">
                    पुँजीको आधारमा तपाईको जम्मा लाग्ने रकम{" "}
                    <span className="text-red-600">रु.{totalAmount}।–</span> मात्र
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="border-primary-blue md:w-[60rem] mt-5 border-2 font-bold">
                  {banijiya_registration_v2.map((item, i) => {
                    const { name, validation, ip1, type } = item;

                    return (
                      <div
                        key={i}
                        className="border-primary-blue flex flex-col border-b md:flex-row"
                      >
                        <p className="text-primary-red px-5 py-2 font-Laila sm:!w-[350px]">
                          {ip1}
                        </p>
                        <input
                          type={type}
                          name={name}
                          className="border-primary-blue w-full border-t py-2 pl-3 md:border-l-2 outline-none md:border-t-0 "
                          {...register(`${name}`, 
                          { onChange: (e) => {e.target.name === "total_capital" && setAmount(e.target.value)} })}
                        
                        
                        />
                      </div>
                    );
                  })}
                  <div className="text-primary-blue max-w-3xl px-5 py-2 border-t border-primary-blue font-Laila text-center">
                    साझेदारहरुको संख्या र पुँजीको आधारमा तपाईको जम्मा लाग्ने रकम{" "}
                    <span className="text-red-600"> रु.{totalAmount}।–</span> मात्र
                  </div>
                </div>
              </>
            )}

            <div>
              <div className="border-primary-red text-base text-primary-blue font-Laila text-center w-fit rounded-full border-2 p-2">
                आयात निर्यात गर्ने उद्देश्यले वाणिज्य विभागमा ब्यवसाय दर्ता
                गर्दा लाग्ने शुल्क सम्बन्धि पूर्ण जानकारी लिनको लागि यहाँ{" "}
                <span
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModalEdit"
                  className="text-primary-red cursor-pointer"
                >
                  Click
                </span>{" "}
                गर्नुहोस ।
                <PrivateCompanyModal
                 paymentRangeList={paymentRangeList}
                   />
              </div>
            </div>
          </div>

          <div className="text-primary-blue text-lg mt-5 underline">
            3. Details of Share Holders <span className="text-primary-blue font-Laila underline">
              (शेयर सदस्य तथा साँक्षीहरुको विवरण) (प्रा.लि. कम्पनीमा बढिमा १०१
              जना सम्म सदस्य रहन सकिन्छ ।)
            </span>
          </div>

          {/* <DetailsOfShareHolders 
        DetailShareholder={banijiya_shareholder_v2}
        needed_share={banijiya_shareholder}
        setShareHolders={setShareHolders}
        shareHolders={shareHolders}
          /> */}
          <DetailsOfShareHolders
            DetailShareholder={pvt_details_of_shareholder_v2}
            needed_share={banijiya_shareholder}
            setShareHolders={setShareHolders}
            shareHolders={shareHolders}
          />
           <div className="text-primary-blue text-lg mt-6 mb-6 underline">
            4. Main Objective
         
          </div>
          <MainObjectives register={register} />

          <div className="text-primary-blue text-lg mt-6 mb-6 underline">
            5. Upload Documents
            <span className="text-primary-blue underline font-laila mx-2 ">
              (यो ब्यवसाय दर्ताको लागि आवश्यक पर्ने निम्न कागजपत्रहरु Upload
              गर्नुहोस् ।)
            </span>
          </div>

          <Documents
            documents_data={banijiya_registration_upload_document}
            initialState={data}
            setDocument={setDocsOutput}
          />
  <div className="text-primary-blue  my-3 underline">
        6. Working Branch
        <span className="text-primary-blue underline  font-Laila mx-2">
          (तपाईले दर्ता गर्न खोज्नुभएको कम्पनी रहने ठेगाना नजिक हाम्रो कुन शाखा
          नजिक पर्छ छनोट गर्नुहोस् ।)
        </span>
      </div>
          <FormBranch register={register} />
          <FormButtom />
          <FormPayment handleSubmit={handleSubmit} handleClick={handleClick}
          setUploadProof={setUploadProof}
          totalAmount={totalAmount}
          // setUploadProof={setUploadProof}
          dueAmount = {dueAmount}
          setPaidAmount = {setPaidAmount}

          />
        </div>
      </form>
    </div>
  );
};

export default BanijyaCompanyRegistrationB;
